import React, { Component } from 'react';
import {
    Tabs as NCTabs,
    Checkbox as NCCheckbox,
    Refer,
} from '@platform/base';
import TipsTitle from './TipsTitle';
import TreeToTreeTransfer from './TreetoTreeTransfer/treeToTree';

import {
    toast,
    ajax,
    getSysFieldid,
    getBusinessInfo,
} from '@platform/api';

require('./userAssign.less');

const NCTabPane = NCTabs.TabPane;

class UserAssign extends Component {
    constructor(props) {
        super(props);
        this.state = {
            foolValue: {}, // 所属组织参照值
            activeReferValue: [],
            value: [],
            treeListTargetKeys: [],
            shareTab: '1', // 左侧tab的key值
            transferDisabled: false,
            selectedPks: [],
        };
        this.tabPks = ['user', 'role', 'org', 'dept'];
        this.tabNames = {
            user: props.multiLang['page-search-0145'] || '用户',
            role: props.multiLang['page-search-0146'] || '角色',
            org: props.multiLang['page-search-0147'] || '所属组织',
            dept: props.multiLang['page-search-0148'] || '部门',
        };
    }
    componentDidMount() {
        this.props.onRef && this.props.onRef(this);

        let rightTreeData = [];

        let tree = this.props.syncTree.createTreeData(rightTreeData);
        this.props.syncTree.setSyncTreeData('transferRight@' + this.props.moduleId, tree);

        let leftTreeData = { dept: [], org: [], role: [], user: [] };
        this.tabPks.forEach(e => {
            let flatTree = this.props.syncTree.createTreeData(leftTreeData[e]);
            this.props.syncTree.setSyncTreeData('transferLeft@' + this.props.moduleId + e, flatTree);
        });

        this.veifyGroupSelected();
    }

    veifyGroupSelected = async () => {
        let { readyShareSchema } = this.props;

        if (Array.isArray(readyShareSchema)) {
            let pk_ncc_queryscheme_arr = [];
            readyShareSchema.forEach(item => {
                pk_ncc_queryscheme_arr.push(item.data.values.pk_ncc_queryscheme.value);
            });
            this.setRightTreeData(pk_ncc_queryscheme_arr);
        } else {
            if (readyShareSchema.values) {
                this.setRightTreeData(readyShareSchema.values.pk_ncc_queryscheme.value);
            } else {
                this.setRightTreeData(readyShareSchema.pk_ncc_queryscheme);
            }
        }

    }

    // 设置左树数据
    setLeftTreeData = async (param, unitFlag, shareTab) => {
        // 左树根据页签创建多个树并加载树数据
        // 若业务单元没有值的话，不必更新左树数据
        let url = '/nccloud/platform/templet/getShareTreeForScheme.do';
        let leftTreeData;
        if (param.length === 0 && !unitFlag) {
            leftTreeData = { dept: [], org: [], role: [], user: [] };
        } else {
            leftTreeData = await this.sendAjax(url, param);
        }
        const activeTab = shareTab || this.state.shareTab;
        const rootPk = this.tabPks[activeTab - 1];
        if (leftTreeData[rootPk]) {
            leftTreeData[rootPk].forEach(item => {
                let newRefName;
                if (item.refcode) {
                    newRefName = item.refname + ' (' + item.refcode + ')';
                } else {
                    newRefName = item.refname + '';
                }
                item.refname = newRefName;
                if (item.fictitious === true && rootPk === 'dept') {
                    item['visibleCheckbox'] = false;
                }
            });
        }
        if (leftTreeData[rootPk] && leftTreeData[rootPk].length) {
            let flatTree = this.props.syncTree.createTreeData(leftTreeData[rootPk]);
            this.props.syncTree.setSyncTreeData('transferLeft@' + this.props.moduleId + rootPk, flatTree);
        } else{
            this.props.syncTree.setSyncTreeData('transferLeft@' + this.props.moduleId + rootPk, []);
        }
    }

    // 设置右树数据
    setRightTreeData = async param => {
        // 而且还得形成右树的初始树数据
        // 右树数据返回后与player联系起来-this.sendAjax()

        // 传过来一个批量分享点击确定的标识，如果为true，那么不走接口查询，直接返回右树为空
        let url = '/nccloud/platform/templet/getRightShareTreeForScheme.do';
        let rightTreeData;

        // 看下多选的情况
        let finalparam = { pk_ncc_queryscheme: param };

        if (this.props.searchRight || (Array.isArray(param))) {
            rightTreeData = [];
        } else {
            rightTreeData = await this.sendAjax(url, finalparam);
        }

        // 若返回的某方案设置过全局，右树不必渲染，置灰
        if (rightTreeData[0] && rightTreeData[0].refpk === 'group') {
            let businessInfo = getBusinessInfo();
            let groupId = businessInfo.groupId || '';
            let groupName = businessInfo.groupName || '';

            this.setState({
                foolValue: { display: groupName, value: groupId },
                transferDisabled: true,
            });
            return;
        }

        // 树显示编码加名称
        rightTreeData.forEach(item => {
            let newRefName;
            if (item.refcode && item.pid) {
                newRefName = item.refname + ' (' + item.refcode + ')';
            } else {
                newRefName = item.refname + '';
            }
            item.refname = newRefName;
            if (item.isleaf) {
                item['oldrefpk'] = item.refpk;
                item.refpk = item.pid + item.refpk;
            }
        });

        let tree = this.props.syncTree.createTreeData(rightTreeData);

        // 右树设置各页签对应数据
        this.props.syncTree.setSyncTreeData('transferRight@' + this.props.moduleId, tree);

        // 取右树的pk,把它更新到selectedPks上传递下去,拿右树铺平的数据
        let treeRightData = this.props.syncTree.getTreeData('transferRight@' + this.props.moduleId);
        let currentTabKeys = this.getChildrenPk(
            treeRightData,
            this.tabPks[this.state.shareTab - 1],
        );

        let flatTreeData = this.props.syncTree.getTreeToList('transferRight@' + this.props.moduleId);
        // 分别取用户、角色下的子节点，传递给树树穿梭框
        let selectedPks = [];
        flatTreeData.forEach(item => {
            selectedPks.push(item.refpk);
        });
        this.setState({ selectedPks: currentTabKeys });
    }

    /**
     * 根据父级pk获取子节点pk
     * @param {*} parentPk
     * @param {*} includeParentPk
     */
    getChildrenPk = (treeData, parentPk, includeParentPk = false) => {
        let allPks = includeParentPk
            ? Array.isArray(parentPk)
                ? parentPk
                : [parentPk]
            : [];
        const loopData = data => {
            for (let i = 0; i < data.length; i++) {
                let { refpk, key, children } = data[i];
                let pk = refpk || key;
                allPks.push(pk);
                if (Array.isArray(children)) {
                    loopData(children);
                }
            }
        };
        const parentNode = this.getItem(treeData, parentPk) || {};
        loopData(parentNode.children || []);
        return allPks;
    };

    /* 根据key获取子树 */
    getItem = (treeData, key) => {
        if (!key) {
            return treeData;
        }
        let length = treeData.length;
        for (let i = 0; i < length; i++) {
            let item = treeData[i];
            if (item.key == key || item.refpk == key) {
                return item;
            } else if (Array.isArray(item.children)) {
                let res = this.getItem(item.children, key);
                if (res) {
                    return res;
                }
            }
        }
    };

    // 发送ajax请求
    sendAjax = (url, param) => {
        return new Promise(resolve => {
            ajax({
                async: true,
                url,
                data: param,
                success: res => {
                    if (!res.success) {
                        throw new Error(res.error.message);
                    }
                    if (res.data && res.data.message) {
                        toast({
                            color: 'warning',
                            content: res.data.message,
                        });
                    }
                    resolve(res.data);
                },
                error: e => {
                    toast({
                        color: e.type || 'danger',
                        content: e.message,
                    });
                },
            });

        });
    };

    // 向表格确认按钮传递分配信息  
    onAllocationInfo = () => {
        this.props.updateAllocation();
    }
    // 页签切换事件
    onTabChange = val => {  
        // 取右树的pk,把它更新到selectedPks上传递下去,拿右树铺平的数据
        let treeRightData = this.props.syncTree.getTreeData('transferRight@' + this.props.moduleId);
        let currentTabKeys = this.getChildrenPk(
            treeRightData,
            this.tabPks[val - 1],
        );
        this.setState({
            shareTab: val,
            selectedPks: currentTabKeys,
        }, () => {
            if (val === '3') {
                this.setLeftTreeData([], true, val);
                let businessInfo = getBusinessInfo();
                let groupId = businessInfo.groupId || '';
                let groupName = businessInfo.groupName || '';
                this.setState({ foolValue: { display: groupName, value: groupId } });
                this.canClearUnitFlag = true;
            } else {
                if (this.canClearUnitFlag) {
                    this.setState({ foolValue: this.state.activeReferValue });
                }
                this.canClearUnitFlag = false;
                this.setLeftTreeData(this.state.value.map(item => item.refpk), false, val);
            }

        });
    };
    // 集团级共享 check onchange 事件
    onCheckChangeByGroup = value => {
        let { shareTab, activeReferValue } = this.state;
        if (value) {
            this.props.syncTree.handleEidAddDisbale('transferRight@' + this.props.moduleId);
            this.props.syncTree.handleEidAddDisbale('transferLeft@' + this.props.moduleId + this.tabPks[shareTab - 1]
            );

            let businessInfo = getBusinessInfo();
            let groupId = businessInfo.groupId || '';
            let groupName = businessInfo.groupName || '';

            this.setState({ foolValue: { display: groupName, value: groupId } });
            this.canClearUnitFlag = true;
        } else {
            this.props.syncTree.handleEidAddNoDisbale('transferRight@' + this.props.moduleId);
            this.props.syncTree.handleEidAddNoDisbale('transferLeft@' + this.props.moduleId + this.tabPks[shareTab - 1]);
            this.setState({ foolValue: activeReferValue });
        }
        this.setState({ transferDisabled: value });
    }

    // 所属组织 refer onChange 事件
    onReferChangeByGroup = (value, foolValue) => {
        let finalRefpks = [];
        if (foolValue.value) {
            if (!foolValue.value.split(',')) {
                finalRefpks.push(foolValue.value);
            } else {
                finalRefpks = foolValue.value.split(',');
            }
        }

        this.setLeftTreeData(finalRefpks);
        // 取右树的pk,把它更新到selectedPks上传递下去,拿右树铺平的数据
        let treeRightData = this.props.syncTree.getTreeData('transferRight@' + this.props.moduleId);
        let currentTabKeys = this.getChildrenPk(
            treeRightData,
            this.tabPks[this.state.shareTab - 1],
        );

        this.setState({
            value,
            foolValue,
            activeReferValue: foolValue,
            selectedPks: currentTabKeys,
        });
    }

    render() {
        let { value, foolValue, shareTab, transferDisabled, selectedPks } = this.state;
        let { multiLang } = this.props;
        let tabNames = [];
        // 角色页签动态显示--根据后端返回的某参数在这里动态添加  TODO： 参数是哪个不清楚
        tabNames = [
            multiLang['page-search-0145'] || '用户',
            multiLang['page-search-0146'] || '角色',
            multiLang['page-search-0147'] || '所属组织',
            multiLang['page-search-0148'] || '部门',
        ];

        return (
            <div className='user-assign'>
                <div className='user-assign-header'>
                    <span className="icon iconfont icon-xinghao"></span>
                    <span className='group-label'>{multiLang['page-search-0147'] || '所属组织'}</span>
                    <div className='group-refer'>
                        <Refer
                            placeholder={multiLang['page-search-0155'] || '请选择'}
                            fieldid="businessUnit"
                            refName={multiLang['page-search-0150'] || '业务单元+集团参照'}
                            rootNode={{ refname: "业务单元+集团", refpk: "root" }}
                            disabled={shareTab === '3' || transferDisabled}
                            type={'popover'}
                            refType={'tree'}
                            refCode={'uapbd.org.BusinessUnitTreeRef'}
                            queryTreeUrl={'/nccloud/uapbd/ref/BusinessUnitAndGroupTreeRef.do'}
                            value={value}
                            foolValue={foolValue}
                            queryCondition={() => {
                                return {
                                    isDataPowerEnable: true,
                                    GridRefActionExt: "nccloud.web.refer.sqlbuilder.PrimaryOrgSQLBuilder",
                                    TreeRefActionExt: 'nccloud.web.refer.sqlbuilder.PrimaryOrgSQLBuilder',
                                };
                            }}
                            onChange={this.onReferChangeByGroup}
                            isMultiSelectedEnabled={true}
                            checkStrictly={true}
                            fieldValued={'refpk'}
                        />
                    </div>
                    <span className='group-check'> {multiLang['page-search-0130'] || '集团级共享'} </span>
                    <NCCheckbox
                        fieldid='groupCheck'
                        checked={transferDisabled}
                        onChange={this.onCheckChangeByGroup}
                    />
                </div>

                <div className="tabsArea" fieldid={getSysFieldid('tabs_area')}>
                    <NCTabs
                        defaultActiveKey="1"
                        onChange={this.onTabChange.bind(this)}
                        // activeKey={shareTab}
                        className="searchTabStyle shareTreeToTreeTab"
                    >
                        {tabNames.map((e, i) => {
                            return (
                                <NCTabPane
                                    tab={
                                        <TipsTitle
                                            className="searchpane"
                                            title={e}
                                        ></TipsTitle>
                                    }
                                    key={i + 1}
                                    disabled={transferDisabled}
                                ></NCTabPane>
                            );
                        })}
                    </NCTabs>
                    <TreeToTreeTransfer
                        activeKey={shareTab} //当前页签key,注意页签索引最小为1
                        tabPks={this.tabPks} //各页签对应的key值，主要用于创建左树的唯一标识
                        tabNames={this.tabNames}
                        syncTree={this.props.syncTree} //同步树方法
                        asyncTree={this.props.asyncTree} //同步树方法
                        moduleId={this.props.moduleId}
                        selectedPks={selectedPks}
                        leftTreeMoudleId={'transferLeft@' + this.props.moduleId + this.tabPks[shareTab - 1]}
                        rightTreeMoudleId={'transferRight@' + this.props.moduleId}
                        onlyShowIncludeAll={shareTab === '1' || shareTab === '2'}
                        showInclude={shareTab === '3' || shareTab === '4'}
                        disabled={transferDisabled}
                        multiLang={multiLang}
                    />
                </div>
            </div>
        );
    }
}

export default UserAssign;
